import create from 'zustand'

type StepNavigationState = {
  currentStep: number
  next: () => void
  setStep: (step: number) => void
  reset: () => void
}

export const useStepNavigationStore = create<StepNavigationState>((set) => ({
  currentStep: 0,
  next: () => set((state) => ({ currentStep: state.currentStep + 1 })),
  setStep: (step) => set({ currentStep: step }),
  reset: () => set({ currentStep: 0 }),
}))
